var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("form-container", { attrs: { size: "medium" } }, [
        _c("h1", { staticClass: "page-title" }, [
          _vm._v(_vm._s(_vm.$t("onboarding.succeededTitle")))
        ]),
        _vm._v(" "),
        _c("h4", { staticClass: "subtitle" }, [
          _vm._v(_vm._s(_vm.$t("onboarding.nextSteps")))
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "item-list" }, [
          _c(
            "li",
            { staticClass: "item" },
            [
              _c("p", [_vm._v(_vm._s(_vm.$t("onboarding.editAccount")))]),
              _vm._v(" "),
              _c(
                "router-link",
                { attrs: { to: { name: "edit" } } },
                [
                  _c("b-button", { attrs: { variant: "primary" } }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("onboarding.editAccountButton")) +
                        "\n          "
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("li", { staticClass: "item" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("onboarding.installApp")) +
                "\n        "
            ),
            _c("div", [
              _c("a", { attrs: { href: _vm.$t("onboarding.iosInstallUrl") } }, [
                _c("img", {
                  staticStyle: { margin: "9px", width: "118px" },
                  attrs: {
                    alt: _vm.$t("onboarding.iosInstallTitle"),
                    src: _vm.$t("onboarding.iosInstallBadgeUrl")
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "a",
                { attrs: { href: _vm.$t("onboarding.androidInstallUrl") } },
                [
                  _c("img", {
                    staticStyle: { margin: "0", width: "135px" },
                    attrs: {
                      alt: _vm.$t("onboarding.androidInstallTitle"),
                      src: _vm.$t("onboarding.androidInstallBadgeUrl")
                    }
                  })
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _vm.showHousebookControlLink
            ? _c(
                "li",
                { staticClass: "item" },
                [
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("onboarding.openHousebookControl")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        href: "https://control.housebook-solutions.com/",
                        target: "_blank",
                        variant: "primary"
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("onboarding.openHousebookControlButton")
                          ) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-169de3f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-169de3f4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OnboardingSuccessScreen.vue
// module id = null
// module chunks = 